import React,{ useState,useEffect} from 'react'
import _ from "lodash";
import {
  
  FormDropdown,
  FormField,
  
} from "../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import Card from "../Components/Atoms/Card/Card";
import ErrorLabel from "../Components/Atoms/ErrorLabel/ErrorLabel";

import { Modal, Button, Form } from 'react-bootstrap';
import {
  CancelButton,
  PrimaryButton,
} from "../Components/Atoms/Button/Button";
import {add_plan_touser,support_ticket_create,branch_list,get_master_data} from "../Enums/api_constunts"
import {postMethod} from "../Helpers/services"
import { showToast } from "../Components/Atoms/ToastNotifier/ToastNotifier";
import { useSelector } from "react-redux";

export default function SupportTicketForm({selectUser,close_me,loaded_from=""}){
  
    const [branchList, setBranchList] = useState([])
    const  [selectedRow, setSelectedRow] = useState(selectUser)
    const [OpenForm,setOpenForm] = useState(0)
    const [subscription_plans, set_subscription_plans] = useState([])
    const [selected_plan, setSelected_plan] = useState(null)
    const userData = useSelector((state) => state.auth.user);
    const [serviceTypes,setServiceTypes] = useState([])
    const [selectedServiceType, setSelectedServiceType] = useState(null)
    const getMasterData = ()=>{
      let postData = {"categories":["md_service_types","md_subscription_plans"]};
      //values["tenant_id"] = _.get(selectedTenant,"id");
      postMethod(get_master_data,postData).then((res)=>{
        
        if(_.get(res,"result.md_service_types",[])){

          let lst =  _.get(res,"result.md_service_types",[]);
          lst = lst.filter((item)=>item.id!=1)
          setServiceTypes( lst.map((item)=>{ item["label"] =  item["name"];return item}))
          
        }
        if(_.get(res,"result.md_subscription_plans.length",0)>0){ 
          let md_plans =   _.get(res,"result.md_subscription_plans",[]).map((item)=>{
             item["label"] =  item["name"]
             
             return item
           });
           set_subscription_plans(md_plans)
         }

        
        
      })
    }

    const [payment_link, setpayment_link] = useState("");
    const [isSpinner, setIsSpinner] = useState(false);
    const [order_details, setorder_details] = useState(false);
    const handleSubmit = (values) => {
      setIsSpinner(true);
      setIsSpinner(true);
      
      postMethod(support_ticket_create,values).then((res)=>{
        showToast("success",_.get(res, "message","Success"))
        setIsSpinner(false);
        
          setOpenForm(0)
         
         close_form()

        
        
        
      }).catch ((error)=>{
        showToast("error",_.get(error, "message","Something went wrong!"))
        setIsSpinner(false);

      })
    };

    const [selectedTenant, setSelectedTenant ] = useState(()=>{
      if(_.get(userData, "tenant_details",null) !=null){
          return { ...userData["tenant_details"], "label":userData["tenant_details"]["name"] }
      
        
      }else{
        return null
      }
        
    })
    const getBranchList = ()=>{
      let postData = {
        "search_string": "",
        "page": 1,
        "per_page": 100,
        "created_on": "",
        "created_to": "",
        "sort_by": "id",
        "sort_order": "desc",
        "status_ids": []
      }
      postMethod(branch_list,postData).then((res)=>{
        if(_.get(res, "list.length") >0){
          let list = res["list"].map((item)=>{
            item["label"] =  item["name"]
            
            return item
          });
          setBranchList(list);
        }
        
      })

    }

    let formData = {
        subject: Yup.string()
          .required("Subject is required")
          .min(5, "Must be at least 5 characters")
          .max(50, "Must be 50 characters or less"),
          description: Yup.string()
          .required("Description is required")
          .min(20, "Must be at least 20 characters")
          .max(1000, "Must be 1000 characters or less"),
        
        
        
        
      }
    let initialValues ={
        subject: "",
        description: "",
    

    }
    
  
    let loanFormik = useFormik({
      initialValues:initialValues,
      validationSchema: Yup.object(formData),
      onSubmit: handleSubmit,
      validateOnBlur: true,
      validateOnChange: true,
    });
  
    
    
    const setDetails = (row , type)=>{
      
      loanFormik.setFieldValue("subject", _.get(row,"subject",""))
      loanFormik.setFieldValue("description", _.get(row,"description",""))
      setSelectedRow(row);
    }
    useEffect(()=>{
      getMasterData()
      getBranchList()
      
    },[])
    useEffect(()=>{

      setDetails(selectedRow)
    },[selectedRow])
    
    useEffect(()=>{
      if(_.get(userData,"role_id")==5){
        setSelectedRow({...userData})
      }
    },[userData]);
    const close_form = ()=>{
      if(close_me){
        close_me(0)
      }
    }
 return (<Card className="">
            <div className="pt-1">
           
              
              
              <div className="row">
               
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Subject"
                    id="subject"
                    name="subject"
                    type="text"
                    value={loanFormik?.values?.subject}
                    onChange={(e)=>{
                       
                      loanFormik.setFieldValue("subject", e.target.value)
                    }
                    }
                    error={loanFormik.touched.email && loanFormik.errors.subject}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={loanFormik.handleBlur}
                  />
                  {loanFormik.touched.subject && (
                    <ErrorLabel
                      name="subject"
                      formik={loanFormik}
                      message={loanFormik.errors.subject}
                    />
                  )}
                </div>
                <Form.Group controlId="description" className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                    as="textarea"
                    rows={4}
                    name="description"
                    value={loanFormik?.values?.description}
                    onChange={loanFormik.handleChange}
                    onBlur={loanFormik.handleBlur}
                    isInvalid={loanFormik.touched.description && loanFormik.errors.description}
                    />
                
                    {loanFormik.touched.description && (
                      <ErrorLabel
                        name="description"
                        formik={loanFormik}
                        message={loanFormik.errors.description}
                      />
                    )}
               </Form.Group>
               
              
                
              
                
                
          
                
              </div>
              <div className="row justify-content-end w-100">
              <div className="d-flex justify-content-end" style={{ gap: "16px" }}>
                <CancelButton label="Cancel" onClick={()=>close_form()} className="btn btn-secondary" />
                <PrimaryButton
                  type="submit"
                  onClick={loanFormik.handleSubmit}
                  spinner={isSpinner}
                  label="Submit"
                  disabled={!(loanFormik.dirty && loanFormik.isValid)}
                />
              </div>            
            </div>
         
        

         


            </div>
          
          </Card>
          )
}